/* eslint-disable no-unused-vars */
import React from 'react';
import { Tags } from 'store/types';
import style from './searchDublication.module.scss';
import isEmpty from 'lodash-es/isEmpty';

import TagsContainer from 'components/tags/tagsContainer';
import ClearAll from '../clearAll/clearAll';
import { TransitionGroup } from 'react-transition-group';
import { tagsWrapTransition } from 'components/transitionWrappers/tagsWrapTransition';
import { GetChipFunction } from 'hooks/useSearchControl';
import cx from 'classnames';

export default function SearchDublication({
  selected,
  getChip,
  clearAll,
}: {
  selected: Tags;
  clearAll: () => void;
  getChip: GetChipFunction;
}) {
  return (
    <>
      <div
        className={cx(
          style.container,
          'searchDublication_container',
          'adaptive-searchDublication_container'
        )}
      >
        <TransitionGroup component={TagsContainer}>
          {tagsWrapTransition({
            tags: selected,
            getChip,
          })}
        </TransitionGroup>
        {!isEmpty(selected) ? <ClearAll clearAll={clearAll}></ClearAll> : ''}
      </div>
    </>
  );
}
